// src/js/storyMap/onMapLoad.js

import { loadTerrain } from '../map/terrainUtils.js';
import { addCustomSourcesAndLayers } from '../map/customLayers.js';
import { setupScrollama } from '../scroll/setupScrollama.js';
import { scaleLayersForMobile } from '../utils/responsiveMapUtils.js';
import { setupInsetMapTracking } from '../map/insetMapManager.js';
import { setupPopups } from './setupPopups.js';


export function onMapLoad(map, config, externalData, insetMap, marker) {
  async function handleLoad() {
    if (config.use3dTerrain) {
      loadTerrain(map);
    }

    if (config.useCustomLayers) {
      await addCustomSourcesAndLayers(map, externalData);
      scaleLayersForMobile(map, externalData.layers);
    }

    // ✅ Safe place to setup popups now that layers are loaded
    if (config.popupLayerName && map.getLayer(config.popupLayerName)) {
      setupPopups(map, config.popupLayerName);
    } else if (config.popupLayerName) {
      console.warn('Popup layer not found:', config.popupLayerName);
    }

    if (config.inset && !config.legend && insetMap) {
      setupInsetMapTracking(map, insetMap);
    }

    setupScrollama(config, map, insetMap, marker);
  }

  map.on('load', handleLoad);
}
